import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { saveScreenSeat } from './utils/sessionManager';
import './App.css';
import { CartProvider } from './context/CartContext';
import { OrderProvider } from './context/OrderContext';
import { PaymentProvider } from './context/PaymentContext';
import { OrderManagerProvider } from './components/OrderManager';
import { KitchenCartProvider } from './context/KitchenCartContext';
import ErrorBoundary from './components/ErrorBoundary';
import SnacksPage from './pages/SnacksPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import HomePage from './pages/HomePage';
import KitchenPage from './pages/KitchenPage';
import KitchenCheckoutPage from './pages/KitchenCheckoutPage';
import setupGlobalErrorHandling from './utils/errorHandler';
import ScreenSeatHandler from './components/ScreenSeatHandler';

function App() {
  // Handle URL parameters and redirect
  useEffect(() => {
    console.log('App.js useEffect running - checking URL parameters');
    
    const location = window.location;
    const pathParts = location.pathname.split('/');
    
    console.log('Current path:', location.pathname);
    console.log('Path parts:', pathParts);
    
    // Check if URL has screen and seat parameters
    // URL format: /snacks/screen5/a4
    if (pathParts.length >= 4 && pathParts[1] === 'snacks') {
      // The second segment is the screen (e.g., 'screen5')
      const screen = pathParts[2];
      // The third segment is the seat (e.g., 'a4')
      const seat = pathParts[3];
      
      console.log('Found screen and seat parameters:', screen, seat);
      
      // Save to session and redirect to snacks page
      saveScreenSeat(screen, seat);
      
      // Check if data was saved successfully
      const savedData = localStorage.getItem('screen_seat_data');
      console.log('Saved data in localStorage:', savedData);
      
      window.history.replaceState({}, '', '/snacks');
      console.log('Redirected to /snacks');
    } else {
      console.log('No screen and seat parameters found in URL');
    }
  }, []);
  // Set up global error handling when the app loads
  useEffect(() => {
    setupGlobalErrorHandling();
  }, []);

  return (
    <ErrorBoundary fallback={<div className="error-fallback">Something went wrong. Please refresh the page.</div>}>
      <CartProvider>
        <OrderProvider>
          <PaymentProvider>
            <OrderManagerProvider>
              <KitchenCartProvider>
                <Router>
                  <div className="App">
                    <Routes>
                  {/* Home page with menu selection */}
                  <Route path="/" element={
                    <ErrorBoundary>
                      <HomePage />
                    </ErrorBoundary>
                  } />
                  
                  {/* Route to handle screen and seat parameters */}
                  <Route path="/snacks/:screen/:seat" element={
                    <ScreenSeatHandler />
                  } />
                  
                  {/* Main snacks page */}
                  <Route path="/snacks" element={
                    <ErrorBoundary>
                      <SnacksPage />
                    </ErrorBoundary>
                  } />
                  
                  {/* Payment page - no longer protected */}
                  <Route path="/pay" element={
                    <ErrorBoundary>
                      <PaymentPage />
                    </ErrorBoundary>
                  } />
                  
                  {/* Payment success page */}
                  <Route path="/payment-success" element={
                    <ErrorBoundary>
                      <PaymentSuccessPage />
                    </ErrorBoundary>
                  } />
                  
                  {/* Kitchen & Bar routes */}
                  <Route path="/kitchen" element={
                    <ErrorBoundary>
                      <KitchenPage />
                    </ErrorBoundary>
                  } />
                  
                  <Route path="/kitchen/checkout" element={
                    <ErrorBoundary>
                      <KitchenCheckoutPage />
                    </ErrorBoundary>
                  } />
                  
                  {/* Catch all undefined routes and redirect to /snacks */}
                  <Route path="*" element={<Navigate to="/snacks" replace />} />
                </Routes>
              </div>
              </Router>
              </KitchenCartProvider>
            </OrderManagerProvider>
          </PaymentProvider>
        </OrderProvider>
      </CartProvider>
    </ErrorBoundary>
  );
}

export default App;
